/**
 * LICITARS 3.0 - Premium Header with Navy/Silver Theme
 */

import React from "react";
import { Bell, Search, HelpCircle, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const AppHeaderV3 = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="bg-navy-700 border-b border-navy-500 px-6 py-4 flex items-center justify-end">
      {/* Right Side Actions */}
      <div className="flex items-center gap-3">
        {/* Help */}
        <Button
          variant="ghost"
          size="icon"
          className="hover:bg-navy-600 text-muted-foreground hover:text-foreground"
        >
          <HelpCircle className="w-5 h-5" />
        </Button>
        <div className="w-px h-6 bg-navy-500"></div>
        {/* User Menu */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-3 hover:opacity-80 transition-opacity">
              <div className="w-9 h-9 gradient-primary-br rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-sm">
                  {user?.username?.[0]?.toUpperCase() || "U"}
                </span>
              </div>
              <div className="xl:block text-left">
                <p className="text-sm font-semibold text-foreground">
                  {user?.username || "Usuário"}
                </p>
                <p className="text-xs text-steel-500">
                  {user?.role || "operador"}
                </p>
              </div>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-navy-600 border-navy-500 w-56" align="end">
            <div className="px-3 py-2">
              <p className="text-sm font-semibold text-foreground">
                {user?.username || "Usuário"}
              </p>
              <p className="text-xs text-muted-foreground">
                {user?.email || "usuario@example.com"}
              </p>
            </div>
            <DropdownMenuSeparator className="bg-navy-500" />
            <DropdownMenuItem
              onClick={handleLogout}
              className="text-foreground hover:bg-navy-500 focus:bg-navy-500 cursor-pointer"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Sair
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default AppHeaderV3;
